import React from 'react';
import { ArtifactContext, IArtifactFormContext } from './ArtifactFormProvider';

export function useArtifactFormContext(): IArtifactFormContext {
  const context = React.useContext(ArtifactContext);
  if (context === undefined) throw new Error('Provider not found.');

  return context;
}
